module.exports = __webpack_public_path__ + "img/icon_map_zzsw_c.a46fde79.png";